export default __webpack_public_path__ + "static/media/apex-logo.27cbb0e2.png";